import { Component, inject } from '@angular/core';
import { CdkMenuItem } from '@angular/cdk/menu';
import { Router, RouterLink } from '@angular/router';
import {
  ButtonDirective,
  CuiDialogService,
  CuiDropdownComponent,
  CuiDropdownTriggerDirective,
} from '@innersource/common-ui-components';
import { ChatWindowService } from '../chat/chat-window.service';
import { UserService } from '../services/api-services/user.service';
import { InfoDialogComponent } from './footer/info-dialog.component';

/** Renders global navigation, account actions, and chat layout controls. */
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  imports: [
    RouterLink,
    CdkMenuItem,
    ButtonDirective,
    CuiDropdownComponent,
    CuiDropdownTriggerDirective,
  ],
})
export class HeaderComponent {
  /** Services. */
  readonly chatWindow = inject(ChatWindowService);
  private readonly dialog = inject(CuiDialogService);
  private readonly router = inject(Router);
  private readonly userService = inject(UserService);

  /** Template forwards. */
  readonly isUserLoggedIn = this.userService.isUserLoggedIn;
  readonly user = this.userService.user;

  /** Opens company information and support links. */
  openAbout(): void {
    this.dialog.open(InfoDialogComponent, { ariaLabel: 'About Hephaestus' });
  }

  /** Opens account settings. */
  async handleSettings(): Promise<void> {
    await this.router.navigate(['settings']);
  }

  /** Signs out and opens the login page. */
  async handleLogout(): Promise<void> {
    await this.userService.logout();
    await this.router.navigate(['login']);
  }
}
